// src/pix-icon.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var PixIcon = createSvgIcon(
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m20.73 9.07-5.8-5.8a4.146 4.146 0 0 0-5.85 0l-5.8 5.8c-.78.78-1.21 1.82-1.21 2.93s.43 2.15 1.21 2.93l5.8 5.8c.81.81 1.87 1.21 2.93 1.21s2.12-.4 2.93-1.21l5.8-5.8a4.146 4.146 0 0 0 0-5.85l-.01-.01Zm-10.6-4.73a2.66 2.66 0 0 1 3.74 0l2.84 2.84c-.88.16-1.44.55-2.13 1.26-.3.31-.58.6-.84.88-.66.7-1.48 1.57-1.73 1.66-.3-.09-1.12-.96-1.77-1.66-.26-.28-.54-.58-.84-.88-.68-.7-1.24-1.1-2.1-1.26l2.84-2.84h-.01ZM3.56 12c0-.71.27-1.37.77-1.87L5.86 8.6c1.45-.07 1.78.18 2.45.87.29.3.57.59.83.87 1.05 1.12 1.75 1.86 2.43 2.07.06.02.14.02.21.03-.06 0-.13 0-.18.03-.63.2-1.24.91-2.16 1.97-.23.26-.48.55-.74.84-.6.67-.85.87-2.16.79l-2.21-2.21c-.5-.5-.77-1.16-.77-1.87V12Zm10.31 7.66a2.638 2.638 0 0 1-3.73 0l-2.17-2.17c.78-.17 1.28-.56 1.86-1.21.27-.3.52-.59.75-.86.51-.59 1.15-1.33 1.43-1.5.29.18.92.91 1.44 1.5.23.27.48.56.75.85.58.65 1.07 1.04 1.85 1.21l-2.17 2.17-.01.01Zm5.79-5.79-2.21 2.21c-1.3.08-1.56-.13-2.15-.79-.26-.29-.5-.57-.73-.84-.92-1.07-1.53-1.77-2.17-1.98-.06-.02-.13-.02-.2-.03.06 0 .14 0 .19-.02.68-.21 1.38-.95 2.43-2.07.26-.27.53-.57.83-.87.68-.7 1.01-.94 2.48-.87l1.53 1.53a2.638 2.638 0 0 1 0 3.73Z"
    }
  ),
  "PixIcon"
);

export {
  PixIcon
};
